import { useMemo } from 'react';
import { mapEquityInfoSerializerToLocalState } from '../utils';
import { useForm } from '@agrotoken-tech/ui';
import { CompanyEquityInformationSerializer } from '@bcba/serializers';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { UpsertCompanyEquityInformationDto } from '../../../../../services/company/dto';

const resolver = classValidatorResolver(UpsertCompanyEquityInformationDto);

export const useEquityInfo = (
  defaultValues?: CompanyEquityInformationSerializer,
) => {
  const apiDataMappedToLocalState = useMemo(() => {
    if (!defaultValues) return;
    return mapEquityInfoSerializerToLocalState(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(defaultValues)]);

  const formMethods = useForm({
    resolver,
    defaultValues: apiDataMappedToLocalState,
  });

  return { formMethods };
};

export default useEquityInfo;
